import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'

import BoxSection from '../Layout/BoxSection'
import Box from '../Layout/Box'
import BoxButton from '../Layout/BoxButton'

const formatter = buildFormatter(spanishStrings)

class Comentarios extends Component {

    render () {

        const { foros, comentario, disabled_comment }=this.props

        if (!foros) return null;

        
        return (
            <BoxSection title="Comentarios">

                <div className="separator"></div>

                <div className="row">

                    <div className='col-md-12'>
                            {
                            foros
                                .sort((a,b) => moment(b.get('updated_at')).unix()-moment(a.get('updated_at')).unix())
                                .map((c,i) => {

                                    // const indicador = c.get('id') ? c.get('id') : c.get('guid')

                                    return (
                                        <Box key={`c[${i}]`}>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <span className="nota-nombre">{ c.getIn(['usuario', 'nombres']) } { c.getIn(['usuario', 'apellidos']) }</span>
                                                    &nbsp;@&nbsp;
                                                    <span className="nota-tiempo">{`${moment(c.get('updated_at')).format('YYYY-MM-DD HH:mm:ss')}`}</span>
                                                </div>
                                            </div>

                                            <div className="separator"></div>
                                            
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    { c.get('comentario') }
                                                </div>
                                            </div>

                                            {/* <div className='row'>
                                                <div className='col-md-12'>                                            
                                                    <div className="text-right">
                                                        <BoxButton title="Editar comentario" name="pencil" onClick={ () => this.props.editarComentario(indicador) }/>
                                                        <BoxButton danger title="Eliminar comentario" name="trash"  onClick={ () => this.props.eliminarComentario(indicador) }/>
                                                    </div>
                                                </div>
                                            </div> */}

                                        </Box>
                                    )
                                })
                            }
                    </div>

                    {foros.count() == 0 && (
                        <div className='col-md-12 text-center'>
                            Agregue comentarios adicionales en esta sección
                        </div>
                    )}

                </div>

                <div className="separator"></div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group text-right">
                            <textarea type="text" className="form-control input-sm" rows={6} value={ comentario.get('texto') || '' } onChange={ (e) => this.props.updateInputs('comentario.texto', e.target.value) } disabled={disabled_comment}/>
                            <div className="separator"></div>
                            <BoxButton name="send"  title="Enviar comentario" onClick={ () => this.props.enviarComentario() } disabled={ ((!disabled_comment) && (comentario.get('texto') && !comentario.get('btnSendDisabled'))) ? false : true }/>
                        </div>
                    </div>
                </div>

            </BoxSection>
        )
    }
}



export default Comentarios


// WEBPACK FOOTER //
// ./src/components/Shared/Comentarios.jsx